module.exports = __webpack_public_path__ + "assets/media/close.fa96168e.svg";